// extracted by mini-css-extract-plugin
export default {"heading":"Zv-z","corrected":"_v-z","redirectVerbiageContainer":"aw-z","redirectVerbiageText":"bw-z"};